<template>
  <v-dialog v-model="show" max-width="600" transition="dialog-bottom-transition" persistent>
    <v-card class="mx-auto">
      <v-toolbar color="primary" dark flat>
        <v-spacer></v-spacer>
        <v-toolbar-title class="text-center">
          Agendamentos encontrados
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <div class="d-flex flex-column align-center mb-6 mt-2">
          <v-avatar class="avatar text-center mb-4" color="primary" size="10rem">
            <img v-if="urlImagem" :src="urlImagem" />
            <v-icon v-else dark size="100">mdi-account</v-icon>
          </v-avatar>
          <div class="nome-paciente-container">
            <span class="nome-paciente">{{ nomePaciente }}</span>
          </div>
        </div>

        <div class="d-flex flex-column align-center">
          <div v-for="(ag, idx) in agendamentos" :key="idx" class="agendamento-card">
            <span class="agenda-nome">Agenda: {{ ag.agenda?.descricao || 'Não informado' }}</span>
            <span class="agendamento-dia">Dia: {{ formatarData(ag.dataAgendamento) }}</span>
            <br>
            <span class="agendamento-hora">às {{ ag.horaAgendamento }}</span>
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn height="40" block outlined color="grey darken-2" v-bind="attrs" v-on="on"
                  class="agendamento-situacao mt-2">
                  <v-icon left dense :color="corDaSituacaoAgendamento(ag.situacaoAgendamento)">
                    {{ iconeDaSituacaoAgendamento(ag.situacaoAgendamento) }}
                  </v-icon>
                  <span :class="`${corDaSituacaoAgendamento(ag.situacaoAgendamento)}--text`">
                    {{ textDaSituacaoAgendamento(ag.situacaoAgendamento) }}
                  </span>
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="item in opcoesSituacaoAgendamento" :key="item.value"
                  @click="clickSituacaoAgendamento(ag, item.value)">
                  <v-list-item-title :text-color="item.color">
                    <v-icon :color="item.color" left dense>{{ item.icon }}</v-icon>
                    <span :class="`${item.color}--text`">{{ ' ' + item.text }}</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>

        <div class="text-center mt-6">
          <div class="font-weight-bold mb-4" style="font-size: 1.2em;">Deseja prosseguir mesmo assim?</div>
          <v-btn color="success" class="mr-4" @click="confirmar">SIM</v-btn>
          <v-btn color="error" @click="cancelar">NÃO</v-btn>
        </div>
      </v-card-text>

      <v-card-actions class="justify-center" v-if="totalPaginas > 1">
        <v-pagination v-model="paginaAtual" :length="totalPaginas" @input="buscarAgendamentos" />
      </v-card-actions>
      <v-dialog v-model="confirmaCancelamentoAgendamento" max-width="800" persistent>
        <v-card>
          <v-card-title class="mr-3">Para concluir o cancelamento, é obrigatório informar o motivo. Por favor, insira o
            motivo
            do cancelamento.</v-card-title>
          <v-card-text>
            <v-textarea class="mr-3" v-model="motivoCancelamento" label="Motivo do cancelamento"
              placeholder="Digite o motivo do cancelamento aqui..." outlined rows="4"></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-btn color="error" @click="fecharDialogCancelamento">Cancelar</v-btn>
            <v-btn color="primary" @click="finalizarCancelamento" :disabled="motivoCancelamento === ''">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import DateHelper from '@/helpers/DateHelper';
import { AgendamentoService } from '@/services/AgendamentoService';
import moment from 'moment';
import { AlertaSimplesErro, MensagemMixin, AlertaPerguntaSimOuNaoBooleano } from '@/helpers/MensagemHelper';

export default {
  name: 'ModalAgendamentosPaciente',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    nomePaciente: {
      type: String,
      default: '',
    },
    pacienteId: {
      type: Number,
      required: true,
    },
    fotoKey: {
      type: String,
      default: '',
    },
    dataNovoAgendamento: {
      type: String,
      default: moment().format('YYYY-MM-DD'),
    },
  },

  data() {
    return {
      show: this.value,
      agendamentos: [],
      paginaAtual: 1,
      totalPaginas: 1,
      totalItens: 0,
      limit: 2,
      carregando: false,
      agendamentoService: new AgendamentoService(),
      urlImagem: '',
      confirmaCancelamentoAgendamento: false,
      motivoCancelamento: '',
      agendamentoSelecionado: null,
      opcoesSituacaoAgendamento: [
        {
          value: 0,
          text: 'Marcado',
          icon: 'mdi-calendar-check',
          color: '#84b6f4',
        },
        {
          value: 1,
          text: 'Em espera',
          icon: 'mdi-clock-alert-outline',
          color: '#77dd77',
        },
        {
          value: 2,
          text: 'Em andamento',
          icon: 'mdi-progress-check',
          color: '#FFA500',
        },
        {
          value: 3,
          text: 'Faltou',
          icon: 'mdi-close-octagon-outline',
          color: '#ff6961',
        },
        {
          value: 4,
          text: 'Finalizado',
          icon: 'mdi-check-circle-outline',
          color: '#c5c6c8',
        },
        {
          value: 5,
          text: 'Cancelado',
          icon: 'mdi-cancel',
          color: '#FFD700',
        },
      ],
    };
  },
  watch: {
    value(val) {
      this.show = val;
      if (val) {
        this.buscarAgendamentos(1);
      }
    },
    show(val) {
      this.$emit('input', val);
    },
    fotoKey: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.urlImagem = `https://medsystemcloud-new.s3.us-west-2.amazonaws.com/${newVal}`;
        } else {
          this.urlImagem = '';
        }
      },
    },
  },
  methods: {
    toDateTimeString(data, hora) {
      const result = DateHelper.toDateTimeString(data, hora);
      return result;
    },
    async buscarAgendamentos(page = 1) {
      this.carregando = true;
      const params = {
        page,
        limit: this.limit,
        dataInicio: this.dataNovoAgendamento,
        dataFim: moment().add(1, 'year').format('YYYY-MM-DD'),
        noCache: Date.now(),
      };
      this.agendamentoService.ListarAgendamentosPorPacientePaginado(
        this.pacienteId,
        params.page,
        params.limit,
        params,
      ).then((res) => {
        const now = moment();
        const agsDiaOuFuturos = (res.data.itens || []).filter((ag) => {
          const agData = moment(ag.dataAgendamento, 'YYYY-MM-DD');
          return agData.isSameOrAfter(now, 'day');
        });

        if (agsDiaOuFuturos.length === 0) {
          this.show = false;
          this.carregando = false;
          return;
        }

        this.agendamentos = agsDiaOuFuturos;
        this.paginaAtual = res.data.paginaAtual || 1;
        this.totalPaginas = res.data.totalPaginas || 1;
        this.totalItens = res.data.totalItens || 0;
        this.carregando = false;
      }).catch(() => {
        this.carregando = false;
      });
    },
    formatarData(data) {
      return DateHelper.formataParaDiaMesAno(data);
    },
    confirmar() {
      this.$emit('confirmar');
      this.show = false;
    },
    cancelar() {
      this.$emit('cancelar');
      this.show = false;
    },
    getSituacaoColor(situacao) {
      const normalizado = situacao.replace(/\s/g, '').toLowerCase();
      switch (normalizado) {
        case 'marcado': return '#84b6f4';
        case 'emespera': return '#77dd77';
        case 'emandamento': return '#FFA500';
        default: return '#bdbdbd';
      }
    },
    getSituacaoLabel(situacao) {
      const normalizado = situacao.replace(/\s/g, '').toLowerCase();
      switch (normalizado) {
        case 'marcado': return 'Marcado';
        case 'emespera': return 'Em espera';
        case 'emandamento': return 'Em andamento';
        default: return situacao;
      }
    },
    corDaSituacaoAgendamento(situacaoAgendamento) {
      const opcao = this.opcoesSituacaoAgendamento.find((x) => x.value === situacaoAgendamento);
      return opcao ? opcao.color : '#bdbdbd';
    },
    iconeDaSituacaoAgendamento(situacaoAgendamento) {
      const opcao = this.opcoesSituacaoAgendamento.find((x) => x.value === situacaoAgendamento);
      return opcao ? opcao.icon : 'mdi-help-circle-outline';
    },
    textDaSituacaoAgendamento(situacaoAgendamento) {
      if (typeof situacaoAgendamento === 'string') {
        if (situacaoAgendamento === 'EmEspera') {
          return 'Em espera';
        }
        if (situacaoAgendamento === 'EmAndamento') {
          return 'Em andamento';
        }
        if (situacaoAgendamento === 'Marcado') {
          return 'Marcado';
        }
        if (situacaoAgendamento === 'Faltou') {
          return 'Faltou';
        }
        if (situacaoAgendamento === 'Finalizado') {
          return 'Finalizado';
        }
        if (situacaoAgendamento === 'Cancelado') {
          return 'Cancelado';
        }
        return situacaoAgendamento;
      }

      const opcao = this.opcoesSituacaoAgendamento.find((x) => x.value === situacaoAgendamento);
      let texto = opcao ? opcao.text : situacaoAgendamento;

      if (situacaoAgendamento === 1) {
        texto = 'Em espera';
      } else if (situacaoAgendamento === 2) {
        texto = 'Em andamento';
      }

      return texto;
    },
    async clickSituacaoAgendamento(agendamento, situacaoAgendamento) {
      try {
        this.carregando = true;
        const response = await this.agendamentoService.Get(agendamento.id);
        const agendamentoCompleto = response.data;

        if (
          agendamentoCompleto.agendamentoConsulta && agendamentoCompleto.agendamentoConsulta.paciente
        ) {
          agendamentoCompleto.agendamentoConsulta.paciente = undefined;
        }

        if (situacaoAgendamento === 5) {
          try {
            const testePermissao = { ...agendamentoCompleto };
            testePermissao.situacaoAgendamento = agendamentoCompleto.situacaoAgendamento;
            await this.agendamentoService.Put(agendamento.id, testePermissao);
          } catch (errorPermissao) {
            let mensagemErroPermissao = '';
            if (errorPermissao?.response?.data) {
              if (typeof errorPermissao.response.data === 'string') {
                mensagemErroPermissao = errorPermissao.response.data;
              } else if (errorPermissao.response.data.Mensagem) {
                mensagemErroPermissao = errorPermissao.response.data.Mensagem;
              } else if (errorPermissao.response.data.message) {
                mensagemErroPermissao = errorPermissao.response.data.message;
              }
            }
            const statusCodePermissao = errorPermissao?.response?.status;
            const naoTemPermissao = statusCodePermissao === 401
              || statusCodePermissao === 403
              || (mensagemErroPermissao && (
                mensagemErroPermissao.toLowerCase().includes('permissão')
                || mensagemErroPermissao.toLowerCase().includes('permission')
                || mensagemErroPermissao.toLowerCase().includes('acesso')
                || mensagemErroPermissao.toLowerCase().includes('não autorizado')
                || mensagemErroPermissao.toLowerCase().includes('unauthorized')
                || mensagemErroPermissao.toLowerCase().includes('forbidden')
                || mensagemErroPermissao.toLowerCase().includes('não tem permissão')
              ));

            if (naoTemPermissao) {
              const nomeAgenda = agendamento.agenda?.descricao || `Agenda ID ${agendamento.agendaId}`;
              const nomeMedico = agendamento.agenda?.usuario?.nomeCompleto || 'o médico responsável';
              AlertaSimplesErro(
                'Acesso não autorizado',
                `Você não possui permissão para cancelar agendamentos na agenda "${nomeAgenda}". Entre em contato com o médico ${nomeMedico} para solicitar acesso.`,
              );
              this.carregando = false;
              return;
            }
          }

          const confirmarCancelamento = await AlertaPerguntaSimOuNaoBooleano(
            'Deseja realmente cancelar esse agendamento?',
            'O agendamento será cancelado, essa ação é irreversível!',
          );
          if (confirmarCancelamento) {
            this.agendamentoSelecionado = agendamentoCompleto;
            this.confirmaCancelamentoAgendamento = true;
            return;
            // eslint-disable-next-line no-else-return
          } else {
            this.carregando = false;
            return;
          }
        }

        agendamentoCompleto.situacaoAgendamento = situacaoAgendamento;

        const putResponse = await this.agendamentoService.Put(agendamento.id, agendamentoCompleto);

        MensagemMixin(1000, 'success', 'Situação do agendamento atualizada com sucesso.');
        await this.buscarAgendamentos(this.paginaAtual);
      } catch (error) {
        let mensagemErro = '';
        if (error?.response?.data) {
          if (typeof error.response.data === 'string') {
            mensagemErro = error.response.data;
          } else if (error.response.data.Mensagem) {
            mensagemErro = error.response.data.Mensagem;
          } else if (error.response.data.message) {
            mensagemErro = error.response.data.message;
          }
        }
        const statusCode = error?.response?.status;
        const naoTemPermissao = statusCode === 401
          || statusCode === 403
          || (mensagemErro && (
            mensagemErro.toLowerCase().includes('permissão')
            || mensagemErro.toLowerCase().includes('permission')
            || mensagemErro.toLowerCase().includes('acesso')
            || mensagemErro.toLowerCase().includes('não autorizado')
            || mensagemErro.toLowerCase().includes('unauthorized')
            || mensagemErro.toLowerCase().includes('forbidden')
            || mensagemErro.toLowerCase().includes('não tem permissão')
          ));

        if (naoTemPermissao) {
          const nomeAgenda = agendamento.agenda?.descricao || `Agenda ID ${agendamento.agendaId}`;
          const nomeMedico = agendamento.agenda?.usuario?.nomeCompleto || 'o médico responsável';
          AlertaSimplesErro(
            'Acesso não autorizado',
            `Você não possui permissão para alterar agendamentos na agenda "${nomeAgenda}". Entre em contato com ${nomeMedico} para solicitar acesso.`,
          );
        } else {
          AlertaSimplesErro('Erro ao atualizar situação do agendamento:', mensagemErro || error);
        }
      } finally {
        this.carregando = false;
      }
    },
    fecharDialogCancelamento() {
      this.confirmaCancelamentoAgendamento = false;
      this.motivoCancelamento = '';
    },
    async finalizarCancelamento() {
      if (!this.agendamentoSelecionado || this.motivoCancelamento === '') {
        return;
      }

      try {
        this.carregando = true;
        this.agendamentoSelecionado.situacaoAgendamento = 5;
        this.agendamentoSelecionado.motivoCancelamentoAgendamento = this.motivoCancelamento;

        const putResponse = await this.agendamentoService.Put(
          this.agendamentoSelecionado.id,
          this.agendamentoSelecionado,
        );

        MensagemMixin(1000, 'success', 'Agendamento cancelado com sucesso.');
        await this.buscarAgendamentos(this.paginaAtual);
        this.fecharDialogCancelamento();
      } catch (error) {
        let mensagemErro = '';
        if (error?.response?.data) {
          if (typeof error.response.data === 'string') {
            mensagemErro = error.response.data;
          } else if (error.response.data.Mensagem) {
            mensagemErro = error.response.data.Mensagem;
          } else if (error.response.data.message) {
            mensagemErro = error.response.data.message;
          }
        }

        const statusCode = error?.response?.status;
        const naoTemPermissao = statusCode === 401
          || statusCode === 403
          || (mensagemErro && (
            mensagemErro.toLowerCase().includes('permissão')
            || mensagemErro.toLowerCase().includes('permission')
            || mensagemErro.toLowerCase().includes('acesso')
            || mensagemErro.toLowerCase().includes('não autorizado')
            || mensagemErro.toLowerCase().includes('unauthorized')
            || mensagemErro.toLowerCase().includes('forbidden')
            || mensagemErro.toLowerCase().includes('não tem permissão')
          ));

        if (naoTemPermissao) {
          const nomeAgenda = this.agendamentoSelecionado?.agenda?.descricao
            || `Agenda ID ${this.agendamentoSelecionado?.agendaId}`;
          AlertaSimplesErro(
            'Acesso não autorizado',
            `Você não possui permissão para cancelar agendamentos na agenda "${nomeAgenda}". Entre em contato com o médico responsável para solicitar acesso.`,
          );
        } else {
          AlertaSimplesErro('Erro ao cancelar agendamento:', mensagemErro || error);
        }
      } finally {
        this.carregando = false;
      }
    },
  },
};
</script>

<style scoped>
.nome-paciente {
  color: #1976d2;
  font-weight: bold;
  font-size: 1.5em;
}

.agendamento-card {
  background: #f5f5f5;
  min-width: 250px;
  max-width: 350px;
  text-align: center;
  border: 1px solid #90caf9;
  margin-bottom: 0.5rem;
  border-radius: 0.5rem;
  padding: 1rem;
}

.agendamento-dia {
  font-weight: bold;
  font-size: 1.1em;
  color: #388e3c;
}

.agendamento-hora {
  font-size: 1.1em;
  color: #1976d2;
}

.agendamento-situacao {
  margin-top: 0.5em;
}

/* CARDS DE AGENDAMENTOS COM GRADIENTE DA ESPECIALIDADE */
.agendamento-card {
  background: var(--especialidade-gradient) !important;
  border: 2px solid var(--especialidade-primary) !important;
  border-radius: 12px !important;
  padding: 1rem !important;
  margin: 0.5rem 0 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  color: white !important;
}

/* TEXTO DENTRO DOS CARDS */

.agendamento-card .agenda-nome {
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 1.15em !important;
  display: block;
  margin-bottom: 0.5rem;
  letter-spacing: 0.5px;
}

.agendamento-card .agendamento-dia {
  color: #ffffff !important;
  /* Azul padrão para a data */
  font-weight: 500 !important;
}

.agendamento-card .agendamento-hora {
  color: white !important;
  font-weight: 500 !important;
}

/* BOTÃO DE SITUAÇÃO */
.agendamento-card .agendamento-situacao {
  background: rgba(255, 255, 255, 0.9) !important;
  border-radius: 8px !important;
  color: var(--especialidade-primary) !important;
}
</style>
